import { render, staticRenderFns } from "./didi_export.vue?vue&type=template&id=2228be06&scoped=true&"
import script from "./didi_export.vue?vue&type=script&lang=js&"
export * from "./didi_export.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2228be06",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2228be06')) {
      api.createRecord('2228be06', component.options)
    } else {
      api.reload('2228be06', component.options)
    }
    module.hot.accept("./didi_export.vue?vue&type=template&id=2228be06&scoped=true&", function () {
      api.rerender('2228be06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/aggregators/didi/didi_export.vue"
export default component.exports